import type { Configuration } from '../..';
import Requester from '../../request/Requester';
import { VoiceChatSocket } from './VoiceChatSocket';

/**
 * Factory for voice-chat WebSocket sessions. Browsers cannot send auth headers on a
 * WebSocket handshake, so the session token (renewed via Requester.getValidToken)
 * travels as the second entry of the subprotocol list.
 */
export class VoiceChatRequester {
  private requester: Requester;
  private host: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.host = configuration.host;
  }

  public createSocket = (): VoiceChatSocket => {
    return new VoiceChatSocket({
      host: this.host,
      getToken: async () => (await this.requester.getValidToken()) ?? null,
    });
  };
}

export default VoiceChatRequester;
